module.exports = "./img/065e690b26dd8f7c3555ee8299842c52.jpg";